/* ========================== 2. Service Layer for API Calls ========================== */
import api from "../config/api";
import { EmployeeSalary } from "../types/EmployeeSalary";

const API_URL = "/employeeSalary";

/* ---------- Get All Salaries ---------- */
export const getSalaries = () =>
  api.get(`${API_URL}/`).then((res) => {
    return res.data.data;
  });
/* ---------- Get Salary by ID ---------- */
export const getSalaryById = (id: number) => api.get(`${API_URL}/?id=${id}`);

/* ---------- Create a New Salary ---------- */
export const createSalary = (data: EmployeeSalary) =>
  api.post(`${API_URL}/`, data);

/* ---------- Update Salary ---------- */
export const updateSalary = (id: number, data: EmployeeSalary) =>
  api.put(`${API_URL}/?id=${id}`, data);

/* ---------- Delete Salary ---------- */
export const deleteSalary = (id: number) => api.delete(`${API_URL}/?id=${id}`);

export const getEmployeeSalaryByEmployeeId = (
  employeeId: string,
  year: string,
  month: string,
) =>
  api.get(`${API_URL}/?employeeId=${employeeId}&year=${year}&month=${month}`);
